module.exports = __webpack_public_path__ + "img/jtb-avatar-7574.05ef8862.jpg";